// redux/slices/routeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  evaluatorStatus: sessionStorage.getItem("evaluator_status") || "0", // Default to "0"
  userRoles: JSON.parse(sessionStorage.getItem("user_roles")) || [], // Default to an empty array
  userInstitutionGroups: null, // Will store the user's institution groups information
};

const routeSlice = createSlice({
  name: "routes",
  initialState,
  reducers: {
    setEvaluatorStatus(state, action) {
      state.evaluatorStatus = action.payload;
      sessionStorage.setItem("evaluator_status", action.payload);
    },
    setUserRoles(state, action) {
      state.userRoles = action.payload;
    },
    setUserInstitutionGroups(state, action) {
      state.userInstitutionGroups = action.payload;
    },
    resetRouteState(state) {
      Object.assign(state, initialState); // Reset Redux store to initial state
    }
  },
});

export const { setEvaluatorStatus, setUserRoles, setUserInstitutionGroups, resetRouteState } = routeSlice.actions;
export default routeSlice.reducer;